import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { useGuest } from '../context/GuestContext';

const GUEST_THEMES = ['light', 'dark', 'cardinals', 'blues'];

const ThemeSelector = () => {
  const { themeName, setThemeName, themes } = useTheme();
  const { isGuest } = useGuest();

  const availableThemes = isGuest
    ? Object.keys(themes).filter(k => GUEST_THEMES.includes(k))
    : Object.keys(themes);

  return (
    <div style={{ padding: '16px' }}>
      <p style={{ fontWeight: '700', marginBottom: '12px', fontSize: '0.9rem' }}>Theme</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {availableThemes.map((key) => (
          <button
            key={key}
            onClick={() => setThemeName(key)}
            style={{
              padding: '10px 14px',
              borderRadius: '8px',
              border: themeName === key ? '2px solid #CC0000' : '2px solid #ddd',
              background: themes[key].cardBackground,
              color: themes[key].text,
              fontWeight: themeName === key ? '700' : '400',
              cursor: 'pointer',
              textAlign: 'left',
              fontSize: '0.9rem',
            }}
          >
            {themeName === key ? '✓ ' : ''}{themes[key].name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemeSelector;